export const DRAG_DROP_UPLOAD_MODAL_EVENT = 'modals:drag-drop-upload';
export const DRAG_DROP_UPLOAD_MODAL_OPEN = `${DRAG_DROP_UPLOAD_MODAL_EVENT}:open`;
export const DRAG_DROP_UPLOAD_MODAL_CLOSE = `${DRAG_DROP_UPLOAD_MODAL_EVENT}:close`;
